import VueI18n from "vue-i18n";

const messages = {
  de: {
    'Ihr Suchprofil': 'Ihr Suchprofil',
    'Welche Immobilie suchen Sie?': 'Welche Immobilie suchen Sie?',
    'weiter': 'weiter',
    'zurück': 'zurück',
    'Formular abschicken': 'Formular abschicken',
    'Wohnen': 'Wohnen',
    'Gewerbe': 'Gewerbe',
    'Kaufen': 'Kaufen',
    'Mieten': 'Mieten',
    'haus': 'Haus',
    'wohnung': 'Wohnung',
    'grundstueck': 'Grundstück',
    'buero_praxis': 'Büro/Praxis',
    'einzelhandel': 'Einzelhandel',
    'hallen_lager': 'Hallen/Lager',
    'gastgewerbe': 'Gastgewerbe',
    'mehrfamilienhaus': 'Mehrfamilienhaus',
    'categoryMarketingTypeBUY': '{category} zum Kauf',
    'categoryMarketingTypeRENT': '{category} zur Miete',
    'marketingTypeBUY': 'Zum Kauf',
    'marketingTypeRENT': 'Zur Miete',
    'Kategorie': 'Kategorie',
    'Umkreis': 'Umkreis',
    'Stadt': 'Stadt',
    'Ortsteil': 'Ortsteil',
    'PLZ': 'PLZ',
    'Standort': 'Standort',
    'Straße': 'Straße',
    'Haus-Nr.': 'Haus-Nr.',
    'Anmeldung': 'Anmeldung',
    'Geben Sie Ihre E-Mail-Adresse ein und folgen Sie den': 'Geben Sie Ihre E-Mail-Adresse ein und folgen Sie den',
    'Anweisungen in der E-Mail': 'Anweisungen in der E-Mail',
    'Es ist ein Fehler aufgetreten.': 'Es ist ein Fehler aufgetreten.',
    'Bitte überprüfen Sie Ihre E-Mail-Adresse.': 'Bitte überprüfen Sie Ihre E-Mail-Adresse.',
    'Löschen': 'Löschen',
    'Bearbeiten': 'Bearbeiten',
    'Ihre gespeicherten Suchprofile': 'Ihre gespeicherten Suchprofile',
    'Suchanfragen': 'Suchanfragen',
    'Möchten Sie Ihr Suchprofil wirklich löschen?': 'Möchten Sie Ihr Suchprofil wirklich löschen?',
    'Speichern': 'Speichern',
    'Abbrechen': 'Abbrechen',
    "currencySymbol": "€",
    "wohnen": "Wohnen",
    "gewerbe": "Gewerbe",
    "kaufen": "Kaufen",
    "mieten": "Mieten",
    "fieldMin": "ab",
    "fieldMax": "bis",
    "fieldYes": "Ja",
    "fieldNo": "Nein",
    "Interessante Objekte": "Interessante Objekte ({n})",
    "Sie wurden abgemeldet": 'Sie wurden abgemeldet',
    'Seite neu laden.': 'Seite neu laden.',
    'userLogout': '{username} abmelden'
  },
  en: {
    'Bitte prüfen Sie Ihre Eingaben.': 'Please check your entries.',
    'Firma': 'Company',
    'Anrede': 'Salutation',
    'Frau,Herr': 'Mrs.,Mr.',
    'Vorname': 'Firstname',
    'Nachname': 'Lastname',
    'Telefon': 'Phone',
    'E-Mail': 'Email',
    'Ihr Wunsch': 'Your request',
    'Besichtigung|besichtigung, Anruf|anruf, Weitere Details|detail': 'sightseeing|tour, call|call, further details|detail',
    'Nachricht': 'Message',
    'Ihre Nachricht wurde erfolgreich verschickt.': 'Your message was successfully sent.',
   'Anfrage senden': 'Send inquiry',
    'Ihr Weg zu uns': 'Your way to us',
    'Nehmen Sie mit uns Kontakt auf und vereinbaren Sie einen persönlichen Besprechungstermin. Wir freuen uns auf Sie.': 'Please contact us and arrange a personal meeting. We look forward to meeting you.',
    'Route jetzt berechnen': 'Calculate route now',
    'Kontaktaufnahme per:': 'Contact per:',
    'Adresse': 'Address',
    'ablehnen': 'decline',
    'Um unsere Webseite für Sie optimal zu gestalten und fortlaufend verbessern zu können, verwenden wir Cookies.': 'In order to design our website optimally for you and to be able to improve it continuously, we use cookies.',
    'Folgende Tools werden eingesetzt:': 'The following tools are used:',
    'Wenn Sie der Verwendung von Cookies nicht zu stimmen werden nur technisch notwendige Cookies gesetzt.': 'If you do not agree to the use of cookies, only technically necessary cookies will be set.',
    'Weitere Informationen zu Cookies erhalten Sie in unserer':'You can find further information on cookies in our',
    'Ich akzeptiere': 'I accept',
    'Die Funktion wurde deaktiviert.': 'The function has been deactivated.',
    'Wussten Sie schon?': 'Did you know?',
    'dass Sie mit einem modernen Browser deutlich schneller und sicherer unterwegs sind?': 'that you are much faster and safer with a modern browser?',
    'Zum Beispiel mit': 'For example with'
  }
};

const numberFormats = {
  de: {
    currency: {
      style: "currency",
      currency: "EUR",
      currencyDisplay: "symbol",
      minimumFractionDigits: 0
    },
    decimal: {
      style: "decimal"
    },
    int: {
      style: "decimal",
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
      useGrouping: false
    }
  }
};

const htmlLang = document.querySelector("html").getAttribute("lang");
let locale = "de";
if (htmlLang == "en-US") {
  locale = "en";
}

export default {
  VueI18n: VueI18n,
  options: {
    locale,
    fallbackLocale: "de",
    messages: messages,
    numberFormats
  }
};
